import { SINGLE_LICENCE_MERCH_ID } from '../settings.json';

export const mutations = {
  SET_OPEN_PLAN(state, plan) {
    state.openPlan = plan;
  },
  SET_PLANS(state, data) {
    const { recurrents } = data;
    state.plans = { ...state.plans, ...recurrents };
  },
  SET_LIFETIME_PLANS(state, data) {
    state.lifetimePlans = data;
  },
  SET_INDIVIDUALS(state, data) {
    const { individuals } = data;
    state.individuals = [...state.individuals, ...individuals];
  },
  SAVE_PLAN(state, plan) {
    const planAlreadySaved = state.savedPlans.some((el) => el.id === plan.id);
    if (!planAlreadySaved) {
      state.savedPlans.push(plan);
    }
  },
  SET_STEP_ACTION(state, action) {
    state.firstStepAction = action;
  },
  SET_PLANS_TO_FETCH(state, newPlansToRender) {
    state.plansToFetch = [...state.plansToFetch, newPlansToRender];
  }
};

export const getters = {
  plansWithIndividual(state, getters, rootState, rootGetters) {
    const merch = rootGetters['experience/getMerch'];

    let individualSimple = SINGLE_LICENCE_MERCH_ID;
    let result = [];

    individualSimple = individualSimple
      ? state.individuals.find((el) => el.id == individualSimple)
      : null;

    const individual = {
      simple: individualSimple
    };

    if (individual.simple) {
      result.push(individual);
    }

    if (state.plans[merch].length) {
      result.push(state.plans[merch][0]);
      result.push(state.plans[merch][1]);
    }

    return result;
  },
  plans(state, getters, rootState, rootGetters) {
    const design = rootGetters['experience/getDesign'];
    const experience = rootGetters['experience/getExperience'] || design;
    return state.plans[experience];
  },
  lifetimePlans(state) {
    return state.lifetimePlans;
  },
  openPlan(state) {
    return state.openPlan;
  },
  getPlanToFetch: (state) => (uId) => {
    return state.plansToFetch.find((elem) => {
      return elem.uId == uId;
    });
  }
};

export const actions = {
  OPEN_PLAN({ commit }, plan) {
    commit('SET_OPEN_PLAN', plan);
  },
  async LOAD_PLANS({ commit, state, rootGetters }) {
    const design = rootGetters['experience/getDesign'];
    const experience = rootGetters['experience/getExperience'] || design;
    if (!state.plans[experience].length) {
      try {
        const response = await this.$axios.get('plan/');
        const data = response.data.data;
        if (data) {
          commit('SET_INDIVIDUALS', { individuals: data.individuals });
          commit('SET_PLANS', { recurrents: { merch: data.merch, design: data.design } });
        }
      } catch (e) {
        console.error('Plans | LOAD_PLANS:', e);
      }
    }
  },
  async GET_PLAN({ commit }, id) {
    try {
      const {
        data: { data, error }
      } = await this.$axios.post(`plan/${id}/`);
      if (!error) {
        commit('SAVE_PLAN', data);
        return data;
      } else {
        console.error('Plans | GET_PLAN 1:', data);
      }
    } catch (error) {
      console.error('Plans | GET_PLAN 2:', error);
    }
  }
};

export const state = () => ({
  plans: {
    merch: [],
    design: []
  },
  individuals: [],
  lifetimePlans: [],
  openPlan: null,
  savedPlans: [],
  plansToFetch: [],
  firstStepAction: ''
});
